import { APP_ROUTES, useAppTranslation } from "@/utils";
import { CheckCircleFilled } from "@payping/icons";

import { Button, Flex, Typography } from "@payping/web-components";
import { Link } from "react-router";

interface SuccessProps {
  callbackMerchant: string;
  merchantName: string;
}
const PrePayCallbackSuccessPage = (props: SuccessProps) => {
  const { t } = useAppTranslation();

  return (
    <Flex vertical className="tw:h-full tw:w-full tw:p-4!">
      <Flex className="tw:my-auto tw:w-full" vertical gap={"large"} align="center">
        <CheckCircleFilled width={80} className="tw:fill-color-success" />
        <Typography.Title level={5} className="tw:m-0! tw:font-semibold">
          {t("pay.prePayCallback.successTitle")}
        </Typography.Title>
        <Link className="tw:w-full" to={APP_ROUTES.home.overview.url}>
          <Button type="link">{t("common.returnToHome")}</Button>
        </Link>
      </Flex>
      <Flex align="center" className="tw:mt-auto tw:w-full" gap={"middle"}>
        <a href={props.callbackMerchant} target="_blank" rel="noreferrer" className="tw:w-full">
          <Button type="primary" block>
            {t("common.returnTo", { name: props.merchantName })}
          </Button>
        </a>
      </Flex>
    </Flex>
  );
};

export default PrePayCallbackSuccessPage;
